<template>

    <SubHeader title="Fiche motif" :breads="[{ name: 'Fiche Motif' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(motifShowItems)">

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" v-model="motifShowItems.label" id="label" class="form-control" placeholder="Motif"
                                        value="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigShowMotif",
    components: {
        SubHeader
    },
    computed: {
        ...mapFields("motif/show", {
            motifShowItems: "item",
            motifShowIsLoading: "isLoading",
            motifShowIsSuccess: "isSuccess",
        }),
        ...mapFields("motif/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated: "isUpdated",
            item: "item",
        })
    },
    methods: {
        ...mapActions({
            reset: "motif/show/resetData",
            resetUpdate: "motif/update/resetData",
            handleSubmit: "motif/update/update",
            getMotif: "motif/show/getOne",
        })
    },
    watch: {
        isUpdated(val){
            if(val){
                this.$router.push({name:'AdminConfigMotif'})
            }
        }
    },
    mounted() {
        this.getMotif(this.$route.params.id ?? 0)
    },
    unmounted() {
        this.reset()
        this.resetUpdate()
    }
}
</script>
